import styled from 'styled-components';
import { Text12ExtraBold, Text15Light, Text15Regular } from '../utils/Text/Text.styles';

export const Container = styled.div`
  border-radius: 16px;
  background: #eef5fd;
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const Title = styled(Text15Regular)`
  color: #3e9be4;
  letter-spacing: -0.15px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`;

export const TextContainer = styled.div`
  border-radius: 16px;
  background: #fff;
  padding: 1.2rem;
  display: flex;
  gap: 1.2rem;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  border: 1px solid ${({ $hasVoice }) => ($hasVoice ? '#97c9f1' : 'transparent')};
`;

export const Text = styled(Text15Light)`
  letter-spacing: -0.15px;
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const SuggestionActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex-shrink: 0;
`;

export const VoiceBadge = styled(Text12ExtraBold)`
  color: #1672ba;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  letter-spacing: -0.15px;
  white-space: nowrap;

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }
`;

export const PlayButton = styled.button`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  background: #eef5fd;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 1.8rem;
    height: 1.8rem;
  }
`;

export const KeepText = styled(Text12ExtraBold)`
  letter-spacing: -0.15px;
  color: #1672ba;
  white-space: nowrap;
`;
